import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';
import arrow from 'assets/arrow.svg';

const PriceListNavigation = () => {
   const [links] = useState([]);
   const [active, setActive] = useState([]);
   const params = useParams();

   useEffect(() => {
      setActive([]);
   }, [params]);

   return (
      <nav>
         {!!links.length && (
            <NavListLevel1>
               {links?.map((level1) =>
                  level1?.tag === 'button' ? (
                     <NavItemLevel1
                        exact
                        key={level1?.id}
                        active={level1.children.some(
                           (el) =>
                              `${el.id}` === params?.priceItemId ||
                              el?.children?.some((item) => `${item.id}` === params?.priceItemId) ||
                              active?.includes(level1?.id)
                        )}
                     >
                        <button
                           type="button"
                           onClick={() => {
                              if (active.includes(level1?.id)) {
                                 setActive([]);
                              } else {
                                 setActive([level1?.id]);
                              }
                           }}
                        >
                           <Arrow
                              active={level1.children.some(
                                 (el) =>
                                    `${el.id}` === params?.priceItemId ||
                                    el?.children?.some(
                                       (item) => `${item.id}` === params?.priceItemId
                                    ) ||
                                    active?.includes(level1?.id)
                              )}
                           >
                              <img src={arrow} alt="" />
                           </Arrow>
                           <ButtonName>{level1?.title}</ButtonName>
                        </button>
                        {level1.children.some(
                           (el) =>
                              `${el.id}` === params?.priceItemId ||
                              el?.children?.some((item) => `${item.id}` === params?.priceItemId) ||
                              active?.includes(level1?.id)
                        ) && (
                           <NavListLevel2>
                              {level1.children.map((level2) => (
                                 <NavItemLevel2 key={level2?.id}>
                                    {level2.tag === 'button' ? (
                                       <>
                                          <button
                                             onClick={() => {
                                                if (active.includes(level2?.id)) {
                                                   setActive((prev) => [prev[0]]);
                                                } else {
                                                   setActive((prev) => [...prev, level2?.id]);
                                                }
                                             }}
                                          >
                                             <Arrow
                                                active={level2.children?.some(
                                                   (el) =>
                                                      `${el.id}` === params?.priceItemId ||
                                                      active?.includes(level2?.id)
                                                )}
                                             >
                                                <img src={arrow} alt="" />
                                             </Arrow>
                                             <ButtonName>{level2?.title}</ButtonName>
                                          </button>
                                          {level2.children?.some(
                                             (el) =>
                                                `${el.id}` === params?.priceItemId ||
                                                active?.includes(level2?.id)
                                          ) && (
                                             <NavListLevel3>
                                                {level2.children?.map((level3) => (
                                                   <NavItemLevel3 key={level3?.id}>
                                                      <StyledNavLink
                                                         exact
                                                         to={`/cennik/${level3?.id}`}
                                                      >
                                                         {level3?.title}
                                                      </StyledNavLink>
                                                   </NavItemLevel3>
                                                ))}
                                             </NavListLevel3>
                                          )}
                                       </>
                                    ) : (
                                       <StyledNavLink to={`/cennik/${level2?.id}`} exact>
                                          {level2?.title}
                                       </StyledNavLink>
                                    )}
                                 </NavItemLevel2>
                              ))}
                           </NavListLevel2>
                        )}
                     </NavItemLevel1>
                  ) : (
                     <NavItemLevel1 key={level1?.id}>
                        <StyledNavLink to={`/cennik/${level1?.id}`}>{level1?.title}</StyledNavLink>
                     </NavItemLevel1>
                  )
               )}
            </NavListLevel1>
         )}
      </nav>
   );
};

const StyledNavLink = styled(NavLink)`
   display: block;
   cursor: pointer;
   color: ${colors.neutral10};
   background: none;
   width: 100%;
   text-align: left;
   border: none;
   padding: 0;

   &:hover {
      text-decoration: none;
      color: ${colors.neutral50};
   }

   &.active {
      color: ${colors.primary};
   }
`;

const List = styled.ul`
   display: block;
   list-style-type: none;
   padding: 0;
   margin: 0 20px 0 0;
   width: 100%;
`;

const NavListLevel1 = styled(List)``;

const NavListLevel2 = styled(List)`
   background: #3a3f40;
   border-radius: 20px;
   padding: 20px;
   margin-top: 10px;

   button {
      margin-top: 10px;
   }
`;

const NavListLevel3 = styled(List)`
   background: ${colors.neutral60};
   border-radius: 20px;
   padding: 20px;
   margin-top: 10px;
`;

const NavItem = styled.li`
   display: block;
   width: 100%;
   padding: 0;
   margin: 0;
   font-size: 14px;

   button {
      display: block;
      cursor: pointer;
      color: ${colors.neutral10};
      background: none;
      width: 100%;
      text-align: left;
      border: none;
      padding: 0;
   }
`;

const Arrow = styled.span`
   display: inline-block;

   img {
      display: block;
      margin: 0 0 3px;
   }

   ${({ active }) =>
      active &&
      css`
         transform: rotate(180deg);

         img {
            margin: 3px 0 0;
         }
      `}
`;

const ButtonName = styled.span`
   display: inline-block;
   padding-left: 10px;
`;

const NavItemLevel1 = styled(NavItem)`
   padding: 7px 0;

   ${({ active }) =>
      !active &&
      css`
         &:not(:last-of-type) {
            border-bottom: 1px solid ${colors.neutral60};
         }
      `}
`;

const NavItemLevel2 = styled(NavItem)`
   padding: 4px 0;
`;

const NavItemLevel3 = styled(NavItem)`
   padding: 4px 0;
`;

export default PriceListNavigation;
